// src/components/layout/SellerDashboardShell.tsx
import React from 'react';
import RoddoPageShell from './RoddoPageShell';

interface SellerDashboardShellProps {
  children: React.ReactNode;
}

const SellerDashboardShell: React.FC<SellerDashboardShellProps> = ({ children }) => {
  return (
    <RoddoPageShell contentClassName="lg:max-w-6xl">
      <div className="min-w-0">{children}</div>
    </RoddoPageShell>
  );
};

export default SellerDashboardShell;
